import { ExcludeWordsContainer } from '../../containers/advancedFilters/ExcludeWordsContainer';
import { IFilter } from '../../types/filters';

export const excludeWords: IFilter = {
  component: ExcludeWordsContainer,
};
